var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99967 16.9173C13.8196 16.9173 16.9163 13.8206 16.9163 10.0007C16.9163 6.18068 13.8196 3.08398 9.99967 3.08398C6.1797 3.08398 3.08301 6.18068 3.08301 10.0007C3.08301 11.0029 3.29556 11.9529 3.6771 12.81C3.88397 13.2748 3.96327 13.8298 3.81494 14.3834L3.15542 16.8448L5.61666 16.1853C6.17027 16.0369 6.72534 16.1163 7.19012 16.3232C8.04735 16.7047 8.99735 16.9173 9.99967 16.9173ZM2.87659 16.9195C2.87649 16.9195 2.87668 16.9195 2.87659 16.9195V16.9195ZM17.9163 10.0007C17.9163 14.3729 14.3719 17.9173 9.99967 17.9173C8.85455 17.9173 7.7662 17.6742 6.78345 17.2367C6.4976 17.1095 6.17771 17.0702 5.87547 17.1512L3.13541 17.8854C2.51576 18.0514 1.94875 17.4844 2.11478 16.8648L2.84901 14.1246C2.92999 13.8224 2.89074 13.5025 2.76351 13.2167C2.32611 12.234 2.08301 11.1457 2.08301 10.0007C2.08301 5.6284 5.62742 2.08398 9.99967 2.08398C14.3719 2.08398 17.9163 5.6284 17.9163 10.0007Z",
    fill: "#5B5C5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.833 10.0007C10.833 10.4609 10.4599 10.834 9.99967 10.834C9.53944 10.834 9.16634 10.4609 9.16634 10.0007C9.16634 9.54041 9.53944 9.16732 9.99967 9.16732C10.4599 9.16732 10.833 9.54041 10.833 10.0007Z",
    fill: "#5B5C5B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1663 10.0007C14.1663 10.4609 13.7932 10.834 13.333 10.834C12.8728 10.834 12.4997 10.4609 12.4997 10.0007C12.4997 9.54041 12.8728 9.16732 13.333 9.16732C13.7932 9.16732 14.1663 9.54041 14.1663 10.0007Z",
    fill: "#5B5C5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49967 10.0007C7.49967 10.4609 7.12658 10.834 6.66634 10.834C6.2061 10.834 5.83301 10.4609 5.83301 10.0007C5.83301 9.54041 6.2061 9.16732 6.66634 9.16732C7.12658 9.16732 7.49967 9.54041 7.49967 10.0007Z",
    fill: "#5B5C5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/Reply.90d185c9b8b8e141b5b614ad288dce53.svg";
export { ForwardRef as ReactComponent };